document.addEventListener('DOMContentLoaded', () => {
  // When collapse toggle element with [data-collapse-toggle-prevent-close="true"] is clicked
  // and the collapse target is already open, then don't close the collapse target
  document.querySelectorAll<HTMLElement>('[data-wf-collapse-toggle-prevent-close="true"]').forEach(elem => {
    const collapseElementId = elem.getAttribute('data-bs-target') || elem.getAttribute('href');
    if (collapseElementId) {
      const collapseElement = document.querySelector<HTMLElement>(collapseElementId);
      if (collapseElement) {
        elem.addEventListener('click', evt => {
          elem.classList.remove('collapsed');
          collapseElement.classList.add('show');
        });
      }
    }
  });
});
